export default __webpack_public_path__ + "static/media/placeholder_chart_horizental_bar.ad95cac7.svg";